/// Menu
//import Metismenu from "metismenujs";
import React, { useContext, useEffect, useReducer, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

//import { Dropdown } from "react-bootstrap";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { Link, useLocation } from "react-router-dom";
//import LogoutPage from './Logout';

/// Image
import { useMenu } from "../../../hooks/useMenu";
import { useMenuManagement } from "../../../context/MenuManagementContext";
import { SubAdminMenuList, UserMenuList, VenueManagerList } from "./Menu";
import { AdminMenuList } from "./Menu";
import AdminSidebar from "./AdminSidebar";
import VenueManagerSidebar from "./VenueManagerSidebar";
import { AuthContext } from "../../../context/AuthContext";
import UserSidebar from "./UserSidebar";
import { toggleSidebar } from "../../../store/actions/UIActions";  
import { useDispatch, useSelector } from "react-redux";
import officialPartner from "../../../images/official-partner.png";
import officialPartnerMini from "../../../images/khelo-mini-logo.png";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const { user, USER_LEVEL } = useContext(AuthContext);
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.ui.isSidebarOpen);
  const loginDetails = JSON.parse(localStorage.getItem("login_Details"));
  const usertype = localStorage.getItem("user_type");
  const menuListData = UserMenuList()

  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);

  // let handleheartBlast = document.querySelector(".heart");
  // function heartBlast() {
  //   return handleheartBlast.classList.toggle("heart-blast");
  // }

  const [hideOnScroll, setHideOnScroll] = useState(true);
   const { menuItems: dynamicMenuItems, loading: menuLoading } = useMenu();
    const { sideabarmenuDataList, fetchSidebarMenuList, sidebarLoading } = useMenuManagement();
    // console.log("sideabarmenuDataList==>",sideabarmenuDataList)
const location = useLocation();
const rawSegments = location.pathname.split("/").filter(Boolean);
const pageLabel = rawSegments.length > 0
  ? rawSegments[rawSegments.length - 1]
      .split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ")
  : "Home";
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  //let scrollPosition = useScrollPosition();
  /// Path

  /// Active menu

  // const filteredSuperAdminMenuList = SuperAdminMenuList.filter((item) => {
  //   if (item?.title === "Client" && loginDetails?.user?.client_id > 0) {
  //     return false;
  //   }
  //   if (
  //     item?.title === "users Category" &&
  //     loginDetails?.user?.client_id === 0
  //   ) {
  //     return false;
  //   }
  //   return true;
  // });
   useEffect(() => {
    fetchSidebarMenuList();
  }, [])

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
      //className="dlabnav"
      // className={`dlabnav ${iconHover} ${
      //   sidebarposition.value === "fixed" &&
      //   sidebarLayout.value === "horizontal" &&
      //   headerposition.value === "static"
      //     ? hideOnScroll > 120
      //       ? "fixed"
      //       : ""
      //     : ""
      // }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          <div className={`toggle_sidebar ${isSidebarOpen ? "arrow-container" : "arrow-container-collapse"}`} >
            <div className={`${isSidebarOpen ? "arrow-btn" : "arrow-btn-collapse"}`} onClick={() => {
              dispatch(toggleSidebar());
              NavMenuToggle();
            }}>
              <i className={`fa fa-lg ${isSidebarOpen ? "fa-angle-left" : "fa-angle-right"}`} />
            </div>
          </div>
          {user?.role === "admin" &&
            (user?.user_level == USER_LEVEL.ADMIN ||
              user?.user_level == USER_LEVEL.SUB_ADMIN ||
              user?.user_level == USER_LEVEL.ADMIN_CHECKER ||
              user?.user_level == "4") && (
              <AdminSidebar
                state={state}
                setState={setState}
                menuListData={sideabarmenuDataList}
                sidebarLoading={sidebarLoading}
              />
            )}

          {/* {usertype === "user" && (
            <UserSidebar
              state={state}
              setState={setState}
              menuListData={userMenuList}
            />
          )} */}

          {usertype === "user" && (
            <UserSidebar
              state={state}
              setState={setState}
              menuListData={menuListData}
            />
          )}
        </ul>
        <div className={`${isSidebarOpen ? "official-partner-container" : "official-partner-container-col"}`}>
            {isSidebarOpen ? (
              <>
                <img
                  src={officialPartnerMini}
                  alt="partner-logo"
                  className="official-partner-mini responsive-mini"
                />
                <img
                  src={officialPartner}
                  alt="partner-logo"
                  className="official-partner responsive-large"
                />
              </>
            ) : (
              <img
                src={officialPartnerMini}
                alt="partner-logo"
                className="official-partner-mini-fixed"
              />
            )}
          </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
